const DOCUMENT_VIEW_SESSION_STORAGE_KEY = 'specific:view-land-document-session-id'
const DOCUMENT_VIEW_SESSION_WINDOW_KEY = '__specificLandViewSessionId'

const createSessionId = () => `${Date.now()}-${Math.random().toString(36).slice(2)}`

export const resolveDocumentViewSessionId = ({
  activeDocumentSessionId,
  navigationType,
  storedSessionId,
  nextSessionId = createSessionId,
}) => {
  if (activeDocumentSessionId) {
    return activeDocumentSessionId
  }

  if (navigationType === 'reload' || !storedSessionId) {
    return nextSessionId()
  }

  return storedSessionId
}

const getSessionStorage = () => {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    return window.sessionStorage || null
  } catch (error) {
    return null
  }
}

const getNavigationType = () => {
  if (typeof window === 'undefined' || typeof window.performance?.getEntriesByType !== 'function') {
    return 'navigate'
  }

  return window.performance.getEntriesByType('navigation')[0]?.type || 'navigate'
}

const initializeDocumentViewSessionId = () => {
  const storage = getSessionStorage()
  const storedSessionId = storage?.getItem(DOCUMENT_VIEW_SESSION_STORAGE_KEY) || null
  const sessionId = resolveDocumentViewSessionId({
    activeDocumentSessionId:
      typeof window !== 'undefined' ? window[DOCUMENT_VIEW_SESSION_WINDOW_KEY] : null,
    navigationType: getNavigationType(),
    storedSessionId,
  })

  if (typeof window !== 'undefined') {
    window[DOCUMENT_VIEW_SESSION_WINDOW_KEY] = sessionId
  }

  try {
    storage?.setItem(DOCUMENT_VIEW_SESSION_STORAGE_KEY, sessionId)
  } catch (error) {
    // The in-memory id remains authoritative when browser storage is unavailable.
  }

  return sessionId
}

const DOCUMENT_VIEW_SESSION_ID = initializeDocumentViewSessionId()

export const createDocumentScopedValue = (value) => ({
  documentViewSessionId: DOCUMENT_VIEW_SESSION_ID,
  value,
})

export const readDocumentScopedValue = (storedValue) => {
  if (
    !storedValue ||
    typeof storedValue !== 'object' ||
    Array.isArray(storedValue) ||
    storedValue.documentViewSessionId !== DOCUMENT_VIEW_SESSION_ID
  ) {
    return null
  }

  return storedValue.value
}
